import { FunctionComponent, memo } from 'react';

import { domainLogo } from '../domain-logo';

const spinnerCircleClassName = 'animate-spin rounded-full border-2 border-button-primary border-t-transparent';

/** Inline spinner. Use for buttons, cells, or inline loading. */
export const InlineSpinner: FunctionComponent<{ className?: string }> = memo(({ className = 'h-12 w-12' }) => (
  <div className={`${spinnerCircleClassName} ${className}`} aria-hidden />
));

/** Full-page loading overlay. Renders fixed over the entire viewport with the Kindly Human Logo. */
export const Spinner: FunctionComponent = memo(() => {
  return (
    <div className="z-200 fixed inset-0 flex h-full w-full items-center justify-center bg-white">
      <div className="flex flex-col items-center gap-y-4">
        <img src={domainLogo} alt="" className="h-12 w-auto sm:h-14" />
        <div className={`h-12 w-12 ${spinnerCircleClassName}`} aria-hidden />
      </div>
    </div>
  );
});
